import {
	createAsyncThunk,
	createSlice
} from "@reduxjs/toolkit";

import { loader } from "../../../core/store/loaderSlice";

export const verifyUserViaOtherOptions = createAsyncThunk(
	"verification/verifyUser",
	async (
		{ apiClient, params, body, options },
		{ dispatch, rejectWithValue }
	) => {
		try {
			dispatch(loader({ open: true }));
			const response = await apiClient.post(
				`/verification`,
				body,
				options
			);
			dispatch(loader({ open: false }));
			return response.data;
		} catch (err) {
			dispatch(loader({ open: false }));
			return rejectWithValue(err.response?.data);
		}
	}
);

export const generateOtp = createAsyncThunk(
	"verification/generateOtp",
	async ({ apiClient, body, options }, { dispatch, rejectWithValue }) => {
		try {
			dispatch(loader({ open: true }));
			const response = await apiClient.post(
				`/generate-otp`,
				body,
				options
			);
			dispatch(loader({ open: false }));
			return response.data;
		} catch (err) {
			dispatch(loader({ open: false }));
			return rejectWithValue({
				msg: err?.response?.data?.msg,
				status: err?.response?.data.status,
				waitTime: err?.response?.data.waitTime,
				statusCode: err?.response?.status
			});
		}
	}
);

const initialState = {
	verificationData: {},
	loading: "pending",
	error: null,
	otpData: {},
	isOtploading: "pending",
	otpError: null
};

const verifyUserSlice = createSlice({
	name: "verificationData",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(verifyUserViaOtherOptions.pending, (state) => {
			state.loading = "pending";
			state.error = null;
		})
			.addCase(
				verifyUserViaOtherOptions.fulfilled,
				(state, action) => {
					state.verificationData = action.payload;
					state.loading = "idle";
					state.error = null;
				}
			)
			.addCase(
				verifyUserViaOtherOptions.rejected,
				(state, action) => {
					state.loading = "idle";
					state.verificationData = {};
					state.error = action.payload;
				}
			);
		// generate otp
		builder.addCase(generateOtp.pending, (state) => {
			state.isOtploading = "pending";
			state.otpError = null;
		})
			.addCase(generateOtp.fulfilled, (state, action) => {
				state.otpData = action.payload;
				state.isOtploading = "idle";
				state.otpError = null;
			})
			.addCase(generateOtp.rejected, (state, action) => {
				state.isOtploading = "idle";
				state.otpData = {};
				state.otpError = {
					...action?.payload
				};
			});
	}
});

export default verifyUserSlice.reducer;
